// /i18n.options.ts

export default {
  legacy: false,
};
